import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { HelperService } from '../../../core/services/helper/helper.service';
import { CommonConstants } from '../../../core/constants/common-constants';
import { LABELS } from '../../../core/constants/label-constants';
import { environment } from 'environments/environment.prod';

@Component({
    selector: 'auth-forgot-password',
    templateUrl: './forgot-password.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        RouterLink,
    ],
})
export class AuthForgotPasswordComponent implements OnInit {
    @ViewChild('forgotPasswordNgForm') forgotPasswordNgForm: NgForm;

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    forgotPasswordForm: UntypedFormGroup;
    showAlert: boolean = false;
    isPartner: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        public _router: Router,
        private _helper: HelperService
    ) {
        this.isPartner = this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1; 
    if(this._router.url.indexOf('/partner-management') !== -1){
            this.isPartner = false;
        } 
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Create the form
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Send the reset link
     */
    sendResetLink(): void {
        // Return if the form is invalid
        if (this.forgotPasswordForm.invalid) {
            return;
        }

        // Disable the form
        this.forgotPasswordForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Forgot password
        this._authService.forgotPassword(this.forgotPasswordForm.get('email').value, this.isPartner).subscribe(
                (response) => {
                    // Set the alert
                    if(response?.meta?.status == 1){
                        this._helper.setSessionData(CommonConstants.FORGOT_EMAIL, this.forgotPasswordForm.get('email').value);
                        this.forgotPasswordForm.enable();
                        this.forgotPasswordNgForm.resetForm();
                        this.showAlert = true;
                        this._helper.toast(response?.meta?.message, 'success');
                        if(this.isPartner){
                            environment.production ? this._router.navigate(['reset-password']) : this._router.navigate(['/partner/reset-password']);
                        } else {
                            this._router.navigate(['/reset-password']);
                        }
                    } else {
                        this.forgotPasswordForm.enable();
                        this._helper.toast(response?.meta?.message, 'error');
                        this.alert = {
                            type: 'error',
                            message: response?.meta?.message
                        };
                    }
                },
                (response) => {
                    // Set the alert
                    this.alert = {
                        type: 'error',
                        message:
                            'Email does not found! Are you sure you are already a member?',
                    };
                }
            );
    }

    protected readonly LABELS = LABELS;
}
